import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ContactRelationshipsService, ContactsService } from '../../../../core/lists';
import { FormControl, Validators } from '@angular/forms';
import * as moment from 'moment';
import { StringUtilsService } from '../../../../core/services/string-utils.service';
import { GeneralAutocompleteComponent } from '../../../partials/layout/general-autocomplete/general-autocomplete.component';
import { GlobalSettingsService } from '../../../../core/services/global-settings.service';
import { FilteredViewService } from '../../../../core/services/filtered-view.service';
import { SubheaderService } from '../../../../core/_base/layout';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LayoutUtilsService } from '../../../../core/_base/crud';
import { TranslateService } from '@ngx-translate/core';
import { FollowUpDialogComponent } from '../../follow-up/follow-up-dialog/follow-up-dialog.component';

@Component({
  selector: 'kt-create-filtered-view-dialog',
  templateUrl: './create-filtered-view-dialog.component.html',
  styleUrls: ['./create-filtered-view-dialog.component.scss'],
})
export class CreateFilteredViewDialogComponent implements OnInit, OnDestroy, AfterViewInit {
  filterStatus: any;
  sessionType: any;
  sessionId;
  @ViewChild('contactAutocomplete') contactAutocomplete: GeneralAutocompleteComponent;
  sessionTypeOptions = [
    {
      label: 'IB Call',
      value: 'IB_CALL',
    },
    {
      label: 'OB Call',
      value: 'OB_CALL',
    },
    {
      label: 'Review',
      value: 'REVIEW',
    },
  ];

  statusOptions = [
    {
      label: 'All Resolved',
      value: 'ALL_RESOLVED',
    },
    {
      label: 'Pending Issues',
      value: 'CALL_NOTE',
    },
    {
      label: 'Client Call Back',
      value: 'CLIENT_CALL_BACK',
    },
  ];

  filterTypeOptions = [
    {
      label: 'Client',
      value: 'CLIENT',
    },
    {
      label: 'Facility',
      value: 'FACILITY',
    },
    {
      label: 'Doctor',
      value: 'DOCTOR',
    },
    {
      label: 'Patient',
      value: 'PATIENT',
    },
  ];

  selectedFilterOption = {
    FACILITY: [],
    DOCTOR: [],
    PATIENT: [],
  };
  contactAutocompleteCall = this.contactsService.searchContactByField.bind(this.contactsService);
  contactSearchFields = this.stringUtils.getEntitySearchFields('CONTACT');
  contactController = new FormControl();
  selectedFilter: any;
  startTime;
  endTime;
  status;
  callId;
  callNote: any;
  availableFilterTypes = {};
  filterType: any;
  selectedFilterOptions = [];
  sessionTypeFormControl = new FormControl(null, Validators.required);
  filterTypeFormControl = new FormControl(null, Validators.required);
  statusFormControl = new FormControl(null, Validators.required);
  private contact: any;
  private intervalList = [];
  isClosing;
  disableConfirmBtn = false;
  allSelected = false;

  constructor(
    private contactsService: ContactsService,
    public dialogRef: MatDialogRef<CreateFilteredViewDialogComponent>,
    private subheaderService: SubheaderService,
    private contactRelationshipsService: ContactRelationshipsService,
    private cdr: ChangeDetectorRef,
    public stringUtils: StringUtilsService,
    private globalSetting: GlobalSettingsService,
    private filteredViewService: FilteredViewService,
    private router: Router,
    private layoutUtilsService: LayoutUtilsService,
    private translate: TranslateService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.isClosing = this.data && this.data.sessionOpened;
    if (this.isClosing) {
      const interval = setInterval(() => {
        this.endTime = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
      }, 1000);
      this.intervalList.push(interval);
    } else {
      const interval = setInterval(() => {
        this.startTime = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
      }, 1000);
      this.intervalList.push(interval);
    }
  }

  ngOnInit(): void {
    if (this.isClosing) {
      this.endTime = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
    } else {
      this.startTime = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
    }
  }

  openFollowUpDialog(contact, session, note) {
    this.dialog.open(FollowUpDialogComponent, {
      data: {
        body: contact,
        type: 'FILTERED_SESSION',
        title: '',
        session,
        calendar: true,
        note,
      },
      width: '1200px',
    });
  }

  onStartClicked() {
    this.filteredViewService.setAllRelatedFilter(this.selectedFilterOptions);
    if (this.isClosing) {
      if (this.statusFormControl.valid) {
        this.disableConfirmBtn = true;
        const closingBody = {
          status: this.status,
          call_note: this.callNote,
        };

        this.subheaderService.sessionInfo$.next(null);
        this.filteredViewService.closeCurrentFilteredView(closingBody).subscribe(
          (res) => {
            if (res) this.sessionId = res.id;
          },
          () => {
            // Intentionally empty: errors from close operation are non-critical
          },
          () => {
            this.globalSetting.setFilteredView(false);
            this.filteredViewService.setFilteredViewId(null);
            this.filteredViewService.setFilteredObject(null);
            this.filteredViewService.setAllRelatedFilter(null);
            this.filteredViewService.setTrackerToken(null);
            this.router.navigate(['/dashboard'], {});
            this.dialogRef.close();
            if (this.status && this.status !== 'ALL_RESOLVED') {
              this.openFollowUpDialog(this.contact, this.sessionId, this.callNote);
            }
          },
        );
      } else {
        this.statusFormControl.markAsTouched();
      }
      return;
    }

    if (this.sessionTypeFormControl.valid && this.filterTypeFormControl.valid && this.contact) {
      this.disableConfirmBtn = true;
      const accessObj = {
        entity_id: this.contact && this.contact.id ? this.contact.id : null,
        access_from: 'Focused View',
        entity_type: 'CONTACT',
      };
      this.filteredViewService.createRecentSession(accessObj).subscribe();
      const filteredObject = {
        sessionType: this.sessionType,
        contact: this.contact,
        filterType: this.filterType.value,
        filterTypeOrigin: this.filterType,
        selectedFilter:
          this.selectedFilter && this.selectedFilter.length
            ? this.selectedFilter.map((e) => {
                return { filter_id: e.entity_id };
              })
            : this.selectedFilterOptions
                .filter((e) => e.entity_type === this.filterType.value)
                .map((e) => {
                  return { filter_id: e.entity_id };
                }),
        selectedFilterOrigin:
          this.selectedFilter && this.selectedFilter.length
            ? this.selectedFilter
            : this.selectedFilterOptions.filter((e) => e.entity_type === this.filterType.value),
        callId: this.data?.callid,
        startTime: new Date(),
      };
      this.filteredViewService.setAllRelatedFilter(this.selectedFilterOptions);
      this.filteredViewService.setFilteredObject(filteredObject);
      this.filteredViewService.setRelatedFilter(
        this.selectedFilter && this.selectedFilter.length
          ? this.selectedFilter
          : this.selectedFilterOptions.filter((e) => e.entity_type === this.filterType.value),
      );
      this.filteredViewService.createdFilteredViewSession().subscribe((res) => {
        this.globalSetting.setFilteredView(true);
        this.filteredViewService.setFilteredViewId(res.body.id);
        this.filteredViewService.setTrackerToken(res.headers.get('trackerToken'));
        this.router.navigate(['filtered-view/dashboard'], {
          queryParams: { isClosing: this.isClosing },
        });
        this.dialogRef.close();
        return;
      });
    } else {
      this.sessionTypeFormControl.markAsTouched();
      this.filterTypeFormControl.markAsTouched();
      this.contactAutocomplete.updateValueAndValidity();
    }
  }

  onSessionTypeChanged() {
    this.cdr.detectChanges();
  }

  onStatusChanged() {
    this.cdr.detectChanges();
  }

  onFilterTypeChanged() {
    this.cdr.detectChanges();
  }

  onContactChange(val) {
    this.contact = val;
    this.filterTypeFormControl.setValue([]);
    if (val && val.id) {
      this.contactRelationshipsService
        .findContactRelationships(val.id, '', true)
        .subscribe((res) => {
          if (res && res.data && res.data.length) {
            this.availableFilterTypes = {};
            this.selectedFilterOptions = res.data;
            for (const entity of res.data) {
              this.availableFilterTypes[entity.entity_type] = true;
            }
            this.cdr.detectChanges();
          } else {
            this._handleEmptyRelationForContact();
            this.contact = null;
          }
        });
    }
  }
  ngOnDestroy(): void {
    this.intervalList.map((e) => clearInterval(e));
  }

  ngAfterViewInit(): void {
    this.filterType = this.filterTypeOptions.filter((e) => e.value === this.data.type)[0];
    this.sessionTypeFormControl.setValue(this.sessionTypeOptions[0].value);
    if (this.isClosing) {
      const filteredObject: any = this.filteredViewService.getFilteredObject();
      // this.sessionType = filteredObject.sessionType;
      this.sessionTypeFormControl.setValue(filteredObject.sessionType);
      this.filterTypeFormControl.setValue(filteredObject.filterTypeOrigin);
      this.availableFilterTypes = {
        FACILITY: true,
        DOCTOR: true,
        PATIENT: true,
      };
      this.filterTypeOptions = [filteredObject.filterTypeOrigin];
      this.selectedFilter = filteredObject.selectedFilterOrigin;
      this.selectedFilterOptions = filteredObject.selectedFilterOrigin;
      this.callId = filteredObject.callId;
      this.startTime = moment(filteredObject.startTime).format('YYYY-MM-DD HH:mm:ss' + 'UTC');
      this.contactAutocomplete.setValue(filteredObject.contact);
      this.cdr.detectChanges();
    }
    if (this.data.entity) {
      this.availableFilterTypes[this.data.type] = true;
      const entity = this.data.entity ? this.data.entity : null;
      this.contactController.setValue(entity);
      this.onContactChange(entity);
      this.contact = entity;
      this.contactAutocomplete.setValue(entity);
      this.cdr.detectChanges();
    }
  }

  private _handleEmptyRelationForContact() {
    const _title = 'No contact relation found';
    const _description =
      'The contact you selected does not have any relation. Please select another contact';
    const _waitDescription = '';
    const dialogRef = this.layoutUtilsService.generalDialog(
      _title,
      _description,
      _waitDescription,
      'Confirm',
      '',
      true,
      false,
    );
    dialogRef.afterClosed().subscribe((res) => {
      if (!res) {
        return;
      }
      this.contactAutocomplete.setValue(null);
    });
  }

  selectAll() {
    this.allSelected = !this.allSelected;
    this.selectedFilter = this.allSelected ? this.selectedFilterOptions : [];
  }
}
